/**
 * OVERRIDE Sitemap.jsx
 */

import Sitemap from '../../../../components/Sitemap/Sitemap';

export default Sitemap;